import BookablePackageRateList from './BookablePackageRateList'

export default BookablePackageRateList